<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <filter-manager
          v-model="searchModel.filters"
          ref="reportFilterRed"
          :filters="filterManagerConfig"
          @search="this.downloadReport"
          items-container-class="flex-wrap"
          :display-advanced="false"
          class="search-bar"
          search-text="Procesar"
          search-icon="fa fa-sync"
          search-container-class="btn-process"
          :is-advanced="false"
        />
      </div>
    </div>
  </div>
</template>


<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import CodeApiServices from '@/services/api/code.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Indicador 14 (Informe Federal)',
      routes: ['Informes', 'Indicador 14 (Informe Federal)'],
    },
    searchModel: {
      collections: {
        academicYears: [],
      },
      filters: {
        academicYear: null,
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYears',
          component: 'CustomDropDown',
          options: this.searchModel.collections.academicYears,
          value: this.searchModel.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          label: 'Año Académico',
          placeholder: 'Seleccione',
          fieldName: 'description',
          fieldKey: 'id',
          validations: 'required',
          error: 'El campo Año Académico es obligatorio.',
        },
      ]
    },
  },
  async mounted() {
    this.initFilters()
  },
  methods: {
    async initFilters() {
      await CodeApiServices.GetFederal14IndicatorFilters().then(
        (res) => {
          this.searchModel = res.data
        }
      )
    },
    async downloadReport() {
      const isValid = await this.$refs.reportFilterRed.$refs.formValidator.validate() 
      if (isValid) {
        reportApi
          .getReport('getFederal14Indicator', {
            AcademicYearId: this.searchModel.filters.academicYear?.id,
          })
          .then((res) => {
            DocumentsService.Download(res.data)
          })
      }
    },
    onChangeAcademicYear(value) {
      this.searchModel.filters.academicYear = value
    },
  },
}
</script>

<style scoped>
.btn-outline-green {
  border: 1px solid var(--highlight-color-button-default);
  border: 1px solid #2db782;
  border-radius: 4px;
  opacity: 1;
  color: #2db782;
}
</style>